<div class="container-fluid">

  <tab-ctrl #tabCtrl [appCodes]="fromDash?[2424]:[2425 , 2424 , 2434 ,1013 ]" [parentUIKey]="UITreeKey"
    (clicked)="activateTab($event)">
  </tab-ctrl>


  <div class="" *ngIf="queryUIKey('2425') || queryVisitedUI('2425')" [hidden]="!queryUIKey('2425')">
    <sanabel-examinationSupply-list #ExaminationSupplyListComponent (Print)="printExam($event)"
      (clicked)="getExaminationDetails($event)"></sanabel-examinationSupply-list>
  </div>

  <div class="" *ngIf="queryUIKey('2424') || queryVisitedUI('2424')" [hidden]="!queryUIKey('2424')">

    <div class="my-2" [hidden]='fromDash'>
      <div class="btn-group" role="group" aria-label="Third group">

        <button class='btn btn-info rounded-0' (click)="NewExamination()">
          <i class="fas fa-sync-alt"></i>

          {{translate.currentLang=='ar'?'محضر جديد':'New Examination'}}
        </button>

        <!-- <button class='btn btn-success rounded-0' (click)="GetPoSupplyList()">
          <i class="fas fa-check"></i> اختر من امر توريد
      </button> -->

      </div>
    </div>

    <div class="master-form" [formGroup]="ExaminationSupplyForm">
      <div class="row">
        <div class="col-sm-3 d-none">
          <div class="form-group">
            <label>{{ 'CODE' | translate }}</label>
            <input type="text" class="form-control form-control-sm" formControlName="serial" disabled />
          </div>
        </div>
        <div class="col-sm-3">
          <label class="col-sm-8">

            {{translate.currentLang=='ar'?'تاريخ الفحص':'Examination Date'}}


          </label>
          <div class="form-group">


            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" formControlName="examinationDate"
                name="dp" ngbDatepicker #dp="ngbDatepicker" required>
              <div class="input-group-addon" (click)="dp.toggle()">
                <i class="fa fa-calendar"></i>
              </div>
            </div>

          </div>
        </div>
        <div class="col-sm-3">
          <sanabel-selectize appcode="154" formControlName="status" #status></sanabel-selectize>
        </div>
        <div class="col-sm-3" [hidden]="fromDash==true">
          <!-- appcode="1078" -->
          <label *ngIf="mode == 2||3">{{ 'Store' | translate }}</label>
          <label *ngIf="mode == 1">{{ 'Pharmacy' | translate }}</label>
          <!-- <label *ngIf="mode == 3">{{ 'ASSETS' | translate }}</label> -->
          <label *ngIf="mode == -5 ">{{ 'THECAFETERIA' | translate }}</label>
          <sanabel-selectize [customPlaceHolder]="placHolder" [SearchKeys]="{Type:mode}" [simpleView]="true"
            appcode="1245" formControlName="storeCode" (clicked)="onStoreClick($event)" #storeByUser>
          </sanabel-selectize>
        </div>
        <div [hidden]="fromDash==false" class="col-sm-3">
          <label>{{ 'Store' | translate }}</label>
          <input type="text" class="form-control form-control-sm" [ngModelOptions]="{standalone: true}"
            [ngModel]="translate.currentLang=='ar'?fromDashAleretObj.storeNameAr:fromDashAleretObj.storeNameEn"
            (ngModelChange)="translate.currentLang == 'ar' ? fromDashAleretObj.storeNameAr : fromDashAleretObj.storeNameEn = $event"
            disabled />
        </div>

        <div class="col-sm-3">
          <sanabel-selectize appcode="1080" formControlName="supSupplierCode" (clicked)="onSupSupplierClick($event)"
            #supSuppierCode [SearchKeys]="{Type:mode}"></sanabel-selectize>
        </div>


        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'MANUALBILLNO' | translate }}</label>
            <input type="text" class="form-control form-control-sm" formControlName="handNumber" />
          </div>
        </div>

        <!-- /_________________________________________________________________________// -->

        <div class="col-sm-1" *ngIf="fromDash" style="padding-top :30px ">
          <label class="custom-control custom-checkbox">{{ 'APROVALSTATUS' | translate }}</label>
        </div>


        <div class="col-sm-1" *ngIf="fromDash" style="padding-top :30px ">
          <div class="form-group">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" formControlName="agree"
                [attr.disabled]="!enableDecision ? 'true' : null" #daysCheckBox
                (change)="statusCheck(daysCheckBox.checked)">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{ 'AGREE' | translate }}</span>
            </label>
          </div>
        </div>

        <div class="col-sm-1" *ngIf="fromDash" style="padding-top :30px ">
          <div class="form-group">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" formControlName="disagree"
                [attr.disabled]="!enableDecision ? 'true' : null" #daysCheckBox1
                (change)="statusCheck(daysCheckBox1.checked)">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{ 'DISAGREE' | translate }}</span>
            </label>
          </div>

        </div>
        <div class="col-sm-3" *ngIf="fromDash"
          style="color: #1E90FF;text-decoration: underline;cursor: pointer; padding-top :30px " (click)="showAppoval()">
          <span> {{'APPROVALWAITING' | translate}} </span>
        </div>



        <!-- /_________________________________________________________________________// -->




      </div>
      <div class="col-sm-2">
        <div class="" style="margin-right: -142px;">
          <button type="button" class="btn btn-info" (click)="NewExamination()">


            {{translate.currentLang=='ar'?'محضر جديد':'New Examination'}}

          </button>
        </div>
      </div>
    </div>


    <div class="col-sm-3" [hidden]="fromDash">
      <sanabel-selectize appcode="162" [(ngModel)]="approvalStatus" (clicked)="onApprovalStatusClick($event)">
      </sanabel-selectize>
    </div>
    <div class="row" [hidden]='fromDash'>
      <!--[hidden]="PoSupplyList != 1"-->


      <div class="col-6">

        <!--table area-->
        <!--header for column name & field for column content-->
        <p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-striped"
          [value]="poOrderSupplyList" [selectionMode]="'single'" [rows]="5" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[5]">


          <p-column field="serial" header="{{translate.currentLang == 'ar'? 'كود امر التوريد': 'Purchase Order Code'}}"
            [sortable]="true"></p-column>
          <p-column field="{{translate.currentLang == 'ar'? 'nameAr': 'nameEn'}}"
            header="{{translate.currentLang == 'ar'? 'اسم المورد': 'Supplier Name'}}" [sortable]="true">
          </p-column>
          <p-column header="{{translate.currentLang == 'ar'? 'تاريخ امر التوريد': 'Purchase Order Date'}}">
            <ng-template pTemplate="options" let-row="rowData">
              <i>{{row['regDate'] | date:'dd/MM/yyyy'}}</i>
            </ng-template>
          </p-column>



          <p-column header="{{ 'STATUS' | translate }}">
            <ng-template pTemplate="options" let-row="rowData">
              <span *ngIf="row.approvalStatus ==1  || row.approvalStatus ==100"> {{'AGREE' | translate}} </span>
              <span *ngIf="row.approvalStatus ==3"> {{'DISAGREE' | translate}} </span>
              <span *ngIf="row.approvalStatus !=3 && row.approvalStatus !=1  && row.approvalStatus !=100 ">
                {{'APPROVALWAITING' | translate}} </span>

            </ng-template>
          </p-column>

          <p-column width="100" header="{{ 'ACTIONS' | translate }}" [style]="{'width': '10%'}">
            <ng-template pTemplate="options" let-row="rowData">
              <icon-action (clicked)="onRowIconClick2($event , row)" [rowData]="row"
                [appCodes]="row['approvalStatus']==100 || row['approvalStatus']==1?[404]:[]"></icon-action>
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>

      <div class="col-6">
        <!--table area-->
        <!--header for column name & field for column content-->
        <p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-striped"
          [value]="itemsInPoOrderSupplyList" [selectionMode]="'single'" [rows]="10" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[5,10,20,50,100]">
          <!-- 1----------------------------------- -->
          <p-column>

            <ng-template pTemplate="header">
              <div class="col-sm-3">

                <label class="custom-control custom-checkbox" style="margin-bottom: 0px;">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="selectAll" name="selectAll"
                    (change)="selectAlll()">
                  <span class="custom-control-indicator"></span>
                </label>

              </div>
            </ng-template>

            <ng-template pTemplate="options" let-row="rowData">
              <div class="col-sm-1">
                <div class="form-group">
                  <label class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="row.selected" name="selected"
                      (change)="OnSelectItem(row)">
                    <span class="custom-control-indicator"></span>
                  </label>
                </div>
              </div>
            </ng-template>

          </p-column>


          <!-- 1----------------------------------- -->
          <p-column class="col-sm-1" field="customID" header="{{ 'ITEMCODE' | translate }}" [sortable]="true">
          </p-column>

          <p-column field="{{translate.currentLang == 'ar'? 'nameAr': 'nameEn'}}" header="{{ 'ITEMNAME' | translate }}">
            <ng-template pTemplate="options" let-row="rowData">
              <i aria-hidden="true" placement="left" ngbTooltip="{{getFactorDesc(row.code)}}">
                <span style="font-size: small;
              font-style: normal;
              font-family: unset;">{{translate.currentLang == 'ar'? row.nameAr: row.nameEn }} </span>
              </i>
            </ng-template>
          </p-column>
          <p-column [style]="{'width': '15%'}"
            field="{{translate.currentLang == 'ar'? 'assetMainDataAr': 'assetMainDataEn'}}"
            header="{{translate.currentLang == 'ar' ? 'اصول مشابهه ' : 'Similar Assets'}}">
            <ng-template pTemplate="options" let-row="rowData">
              <i aria-hidden="true" placement="left">
                <span style="font-size: small;
font-style: normal;
font-family: unset;">{{translate.currentLang == 'ar'? row.assetsMainDataAr: row.assetsMainDataEn }} </span>
              </i>
            </ng-template>
          </p-column>

        </p-dataTable>
      </div>


    </div>

    <div class="row" [hidden]="linkId == 6578 || fromDash">
      <div class="col-sm-3">
        <div class="form-group">
          <label style="color: red;">
            {{translate.currentLang=='ar'?'أضافة هدية':'Add Gift'}}
          </label>
          <sanabel-selectize appcode="1106" [SearchKeys]="{Type:mode}" [multi]="true" [simpleView]="true"
            (addSelected)="addItem($event)" #itemMainData></sanabel-selectize>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="makeExaminationWithoutOrderSupply==1">
      <div class="col-sm-3" [hidden]="(linkId == 6578 || fromDash) ">
        <div class="form-group">
          <label style="color: red;">
            {{translate.currentLang=='ar'?'اضافة الصنف':'Add item'}}
          </label>
          <sanabel-selectize appcode="1106" [SearchKeys]="{Type:mode}" [multi]="true" [simpleView]="true"
            (addSelected)="addDirectItemFromExamination($event)" #itemMainData></sanabel-selectize>
        </div>
      </div>
    </div>



    <div class="row" [hidden]="linkId != 6578 || fromDash">
      <div class="col-sm-3">
        <div class="form-group">
          <label style="color: red;">
            {{translate.currentLang=='ar'?'أضافة هدية':'Add Gift'}}
          </label>
          <sanabel-selectize appcode="1157" [simpleView]="true" (clicked)="onAssetsClick($event)" #transStatus>
          </sanabel-selectize>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="makeExaminationWithoutOrderSupply==1">
      <div class="col-sm-3" [hidden]="(linkId != 6578 || fromDash) ">
        <div class="form-group">
          <label style="color: red;">
            {{translate.currentLang=='ar'?'اضافة الصنف':'Add item'}}
          </label>
          <sanabel-selectize appcode="1157" [simpleView]="true" (clicked)="onAssetsItemFromExaminationClick($event)"
            #transStatus>
          </sanabel-selectize>
        </div>
      </div>
    </div>

    <p-dataTable tableStyleClass="table table-bordered table-striped cadetblue" [value]="items" [rows]="10"
      [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]">
      <p-column [style]="{'width': '4%'}">
        <ng-template pTemplate="options" let-row="rowData">
          <i class="fa fa-trash" (click)="deleteRow(row)"></i>
        </ng-template>
      </p-column>

      <p-column [style]="{'width': '3%'}" field="gift" header="{{translate.currentLang=='ar'?'هدية':'Gift'}}">
        <ng-template pTemplate="options" let-row="rowData">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="custom-control custom-checkbox">
                <input disabled type="checkbox" class="custom-control-input" [(ngModel)]="row.gift" name="gift">
                <span class="custom-control-indicator"></span>
              </label>
            </div>
          </div>
        </ng-template>
      </p-column>
      <p-column [style]="{'width': '10%'}" field="customID" header="{{ 'ITEMCODE' | translate }}">
      </p-column>
      <p-column [style]="{'width': '15%'}" field="{{translate.currentLang == 'ar'? 'nameAr': 'nameEn'}}"
        header="{{ 'ITEMNAME' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
          <i aria-hidden="true" placement="left" ngbTooltip="{{getFactorDesc(row.code)}}">
            <span style="font-size: small;
            font-style: normal;
            font-family: unset;">{{translate.currentLang == 'ar'? row.nameAr: row.nameEn }} </span>
          </i>
        </ng-template>
      </p-column>
      <p-column [style]="{ width: '10%' }" field="patchCodeStr" header="{{ 'PATCHNOIN' | translate }}">
        <ng-template pTemplate="options" let-row="rowData" let-rowIndex="rowIndex">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="row.patchCodeStr" name="patchCodeStr"
            id="tab{{row['index']}}" [idName]="'tab'" [tabindex]="row['index']" [itemsLength]="items.length" />
        </ng-template>
      </p-column>
      <p-column [style]="{'width': '10%'}" field="unitCode" header="{{ 'UNIT' | translate }}" [hidden]="linkId == 6578">
        <ng-template pTemplate="options" let-row="rowData">
          <select class="form-control  form-control-sm " id="row.code" [(ngModel)]="row.unitCode" name="unitCode">
            <option *ngFor="let unit of itemUnits | itemDataFilter: row.code" [value]="unit.serial">
              {{translate.currentLang == 'ar'? unit.nameAr: unit.nameEn}}
            </option>
          </select>
        </ng-template>
      </p-column>

      <p-column [hidden]="hiddenQuantityFromExamination ==1" field="remain" header="{{ 'QUANTITY' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
          <input type="text" class="form-control form-control-sm" numbersOnly [(ngModel)]="row.remain" name="remain"
            id="tab{{row['index']}}" [idName]="'tab'" [tabindex]="row['index']" [itemsLength]="items.length" disabled />
        </ng-template>
      </p-column>

      <p-column [hidden]="hiddenQuantityFromExamination ==1" [style]="{'width': '10%'}" field="supplyQty"
        header="{{ 'SUPLIERQUANTITY' | translate }}" [sortable]="true">
        <ng-template pTemplate="options" let-row="rowData">
          <input type="text" class="form-control form-control-sm" numbersOnly [(ngModel)]="row.supplyQty"
            (keyup)="onSupplyQtyQtyChange($event ,row)" name="supplyQty" id="tab1{{row['index']}}" [idName]="'tab1'"
            [tabindex]="row['index']" [itemsLength]="items.length" />
        </ng-template>
      </p-column>
      <p-column [style]="{'width': '10%'}" field="acceptQty" header="{{ 'ACCEPTQUANTITY' | translate }}"
        [sortable]="true">
        <ng-template pTemplate="options" let-row="rowData">
          <input type="text" class="form-control form-control-sm" numbersOnly [(ngModel)]="row.acceptQty"
            (keyup)="onAcceptQtyChange($event ,row)" name="acceptQty" id="tab2{{row['index']}}" [idName]="'tab2'"
            [tabindex]="row['index']" [itemsLength]="items.length" />
        </ng-template>
      </p-column>
      <p-column [hidden]="hiddenQuantityFromExamination ==1" [style]="{'width': '10%'}" field="rejectQty"
        header="{{ 'REJECTQUANTITY' | translate }}" [sortable]="true">
        <ng-template pTemplate="options" let-row="rowData">
          <input type="text" class="form-control form-control-sm" numbersOnly [(ngModel)]="row.rejectQty"
            name="rejectQty" disabled />
        </ng-template>
      </p-column>
      <p-column [hidden]="hiddenQuantityFromExamination ==1" [style]="{'width': '10%'}" field="reasonOfReject"
        header="{{ 'REASONOFREJECT' | translate }}" [sortable]="true">
        <ng-template pTemplate="options" let-row="rowData">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="row.reasonOfReject"
            name="reasonOfReject" />
        </ng-template>
      </p-column>

      <p-column [hidden]="makeExaminationWithoutOrderSupply !=1" [style]="{'width': '15%'}" field="expirationDate"
        header="{{ 'EXPIRADATE' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
          <div [hidden]="row['expiry'] != true" class="input-group input-group-sm">
            <input required [ngClass]="{'activeTab': row.errorselected == 1}" class="form-control"
              placeholder="{{'DATEFORMAT' | translate}}" [(ngModel)]="row.expirationDate" name="dp" ngbDatepicker
              #dp="ngbDatepicker" (navigate)="expirationDateClick(row)">
            <div class="input-group-addon" (click)="dp.toggle()">
              <i class="fa fa-calendar"></i>
            </div>
          </div>
        </ng-template>
      </p-column>
    </p-dataTable>

    <div class="row">
      <div class="col">
        <btns-ctrl #btnCtrl1 [disabled]="ExaminationSupplyForm.invalid" [appCodes]="fromDash?[2]:[1,2]"
          (clicked)="onClicked($event)"></btns-ctrl>
      </div>
    </div>


  </div>

  <div class="" *ngIf="queryUIKey('2434') || queryVisitedUI('2434')" [hidden]="!queryUIKey('2434')">
    <app-examination-committee></app-examination-committee>
  </div>

  <div class="" *ngIf="queryUIKey('1013') || queryVisitedUI('1013')" [hidden]="!queryUIKey('1013')">
    <examination-supply-print></examination-supply-print>
  </div>

</div>

<!------------------------------ popup-->
<block-modal-container #content (close)="onpopupClose($event)">
  <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
</block-modal-container>
<!------------------------------ end popup ------------------------------------>